var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPageCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.875 1.5V18.375C27.875 21.4875 25.3625 24 22.25 24H11C7.8875 24 5.375 21.4875 5.375 18.375V1.5H27.875Z",
    fill: "#2F4C21",
    stroke: "#2F4C21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.875 1.5H33.5C34.5313 1.5 35.375 2.34375 35.375 3.375V9C35.375 10.0313 34.5313 10.875 33.5 10.875H27.875",
    stroke: "#2F4C21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.625 31.5H16.625H1.625",
    stroke: "#2F4C21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageCoffee);
export default __webpack_public_path__ + "static/media/landing_page_coffee.adb72ee3e72bf822bd4dd8ad984fbc84.svg";
export { ForwardRef as ReactComponent };